<template>
  <div>
    <template v-for="field in fields">
      <ValueHelpWrapper
        v-if="field.type == 'value-help-v2'"
        :key="field.name"
        :field="field"
        :value="formValues[field.name]"
        :fullObject="fullObjects[field.name] || []"
        @input="$emit('update:formValues', { key: field.name, value: $event })"
        @update:fullObject="$emit('update:fullObjects', { key: field.name, value: $event })"
      />
      <RangeInput v-else-if="field.type === 'range-input'" :key="field.key" :fields="field" />
      <FormulateInput v-else v-bind="field" :key="field.name" />
    </template>
  </div>
</template>

<script>
import ValueHelpWrapper from './wrapper/ValueHelpWrapper'
import RangeInput from './wrapper/RangeInput'
import { getTableFilterFields } from './lib/table-filter-fields'

export default {
  components: {
    RangeInput,
    ValueHelpWrapper,
  },
  props: {
    formValues: {
      type: Object,
      default: () => {},
    },
    fullObjects: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['update:formValues', 'update:fullObjects'],
   data() {
    return {
      fields: [],
    }
  },
  watch: {
    '$i18n.locale'() {
      this.updateFields()
    },
  },
  mounted() {
    this.updateFields()
  },
  methods: {
    updateFields() {
      this.fields = getTableFilterFields().filter((field) => field.isShow)
    },
  },
}
</script>
